import React from "react";

export const PRINT_DEFAULTS = { text_style: "bold", font_face: "times", min_text: false, thick_lines: false };
const SIZES = [["standard", "Standard"], ["bold", "Bold"], ["larger", "Larger"], ["xlarge", "Extra large"], ["smaller", "Smaller"]];
const FACES = [["times", "Times (serif)"], ["sans", "Helvetica (scan-safe)"]];

function Seg({ name, opts, value, onChange, disabled, allowDefault }) {
  const all = allowDefault ? [[null, "Workspace default"], ...opts] : opts;
  return (
    <div className="flex flex-wrap gap-1" data-testid={`print-${name}`}>
      {all.map(([v, l]) => (
        <button key={String(v)} type="button" disabled={disabled} onClick={() => onChange(v)} data-testid={`print-${name}-${v ?? "default"}`}
          className={`px-2.5 py-1 rounded-full text-xs border transition-colors ${value === v ? "bg-[#0b1f3a] text-white border-[#0b1f3a]" : "bg-white text-slate-700 border-slate-300 hover:border-slate-500"} disabled:opacity-60`}>{l}</button>
      ))}
    </div>
  );
}

function Check({ name, label, hint, value, onChange, disabled, allowDefault }) {
  const tri = allowDefault && (value === null || value === undefined);
  return (
    <label className="flex items-start gap-2 text-sm cursor-pointer">
      <input type="checkbox" className="h-4 w-4 mt-0.5 accent-[#0f3d2a]" disabled={disabled} checked={!!value} ref={(el) => el && (el.indeterminate = tri)}
        onChange={(e) => onChange(e.target.checked)} data-testid={`print-${name}`} />
      <span><span className="font-medium">{label}</span>{tri && <span className="text-xs text-slate-400"> · workspace default</span>}<span className="block text-xs text-slate-500">{hint}</span></span>
    </label>
  );
}

/** Print legibility options shared by Settings (workspace default), New affidavit, and the Layout dialog (per-affidavit; null = workspace default). */
export function PrintStyleControls({ value, onChange, disabled, allowDefault, compact }) {
  const lo = value || {};
  const set = (k) => (v) => onChange({ ...lo, [k]: v });
  return (
    <div className={compact ? "space-y-2" : "space-y-3"} data-testid="print-style-controls">
      <div><div className="text-[11px] text-slate-500 mb-1">Text size &amp; weight <span className="text-slate-400">— Bold / Larger stay dark on a court's low-res scan</span></div><Seg name="size" opts={SIZES} value={lo.text_style ?? null} onChange={set("text_style")} disabled={disabled} allowDefault={allowDefault} /></div>
      <div><div className="text-[11px] text-slate-500 mb-1">Typeface <span className="text-slate-400">— Helvetica's even strokes survive scanning better than Times' thin serifs</span></div><Seg name="face" opts={FACES} value={lo.font_face ?? null} onChange={set("font_face")} disabled={disabled} allowDefault={allowDefault} /></div>
      <div className="grid sm:grid-cols-2 gap-2">
        <Check name="min-text" label="10pt minimum" hint="Nothing on the page (attempts table, GPS, notary fine print) prints below 10pt." value={lo.min_text} onChange={set("min_text")} disabled={disabled} allowDefault={allowDefault} />
        <Check name="thick-lines" label="Thicker lines" hint="Signature lines, table borders and rules at 1.2pt so they don't vanish." value={lo.thick_lines} onChange={set("thick_lines")} disabled={disabled} allowDefault={allowDefault} />
      </div>
    </div>
  );
}
